/* The product picker stays open; the shared size finder is the topmost modal. */
(()=>{
  'use strict';
  if(window.r24LatestPolish)return;window.r24LatestPolish=true;
  const rm=matchMedia('(prefers-reduced-motion:reduce)'),d=document;
  const dialog=d.getElementById('r24-size-dialog'),sheet=d.querySelector('[data-r19-sheet]');
  if(dialog&&sheet){
    const finder=dialog.querySelector('r24-fit-finder');
    let opener=null,version=0;
    d.addEventListener('click',async event=>{
      const link=event.target.closest('[data-r19-sheet-guide]');
      if(!link||!sheet.open)return;
      const selection=sheet.venluFitSelection;
      let handle;
      try{
        const url=new URL(selection?.productURL,location.href);
        if(url.origin!==location.origin)return;
        handle=/\/products\/([^/]+)\/?$/.exec(url.pathname)?.[1];
        if(!handle)return;
      }catch(_){return;}
      event.preventDefault();opener=link;const token=++version;
      dialog.dataset.pointerOpen=String(event.detail>0);
      if(!dialog.open)dialog.showModal();
      dialog.querySelector('[data-size-content]').scrollTop=0;
      dialog.querySelector('[data-size-close]').focus({preventScroll:true});
      await customElements.whenDefined('r24-fit-finder');
      if(dialog.open&&version===token)finder.loadHandle(decodeURIComponent(handle),selection);
    });
    dialog.addEventListener('click',event=>{
      if(event.target.closest('[data-size-close]')){dialog.close();return;}
      if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}
    });
    dialog.addEventListener('close',()=>{
      version++;finder.cancelLoad?.();
      if(sheet.open&&opener?.isConnected)opener.focus({preventScroll:true});
    });
    sheet.addEventListener('close',()=>{if(dialog.open)dialog.close();});
    window.addEventListener('pagehide',()=>{version++;finder.cancelLoad?.();if(dialog.open)dialog.close();});
  }
  function choppers(root=d){
    root.querySelectorAll('[data-r24-chopper]:not([data-chopper-bound])').forEach(button=>{
      button.dataset.chopperBound='true';const img=button.querySelector('img');let movement=null,timer=null;
      const play=()=>{
        movement?.cancel();clearTimeout(timer);button.classList.add('is-playing');
        if(!rm.matches)movement=img.animate([{transform:'translateY(0) rotate(0)'},{transform:'translateY(-5px) rotate(-5deg)',offset:.24},{transform:'translateY(0) rotate(3deg)',offset:.52},{transform:'translateY(-2px) rotate(-2deg)',offset:.74},{transform:'translateY(0) rotate(0)'}],{duration:780,easing:'cubic-bezier(.22,1,.36,1)'});
        timer=setTimeout(()=>button.classList.remove('is-playing'),1600);
      };
      button.addEventListener('click',play);
      button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')play();});
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(([entry])=>{if(entry.isIntersecting){observer.disconnect();if(!rm.matches)play();}},{threshold:.8});observer.observe(button);}
      rm.addEventListener('change',()=>{if(rm.matches)movement?.cancel();});
    });
  }
  function entrances(root=d){
    const elements=root.querySelectorAll('[data-review-demo],.r19-footer__social');
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-seen');observer.unobserve(entry.target);}}),{threshold:.2});elements.forEach(el=>observer.observe(el));
  }
  choppers();entrances();d.addEventListener('shopify:section:load',event=>{choppers(event.target);entrances(event.target);});
})();
